import { useApolloClient } from "@apollo/client";
import { useAccount, useMsal } from "@azure/msal-react";
import { useState } from "react";
import { FaRegCircleUser } from "react-icons/fa6";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import useAuthToken from "../../hook/useAuthToken";
import { notifyError } from "../../services/notification";

export default function UserMenu() {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);

    const [getAccessToken] = useAuthToken();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const client = useApolloClient();

    // Logout using GraphQL mutation will throw 403 after session invalidated; changed to use REST API
    const logout = async () => {
        const token = await getAccessToken()

        fetch('api/logout', {
            method: 'POST',
            headers: {
                "Content-type": "application/json; charset=UTF-8",
                ...(token && { "Authorization": `Bearer ${token}` })
            }
        })
            .then(response => {
                if (response.ok) {
                    console.log("log out user")
                    client.clearStore()
                    instance.logout()
                } else {
                    notifyError("An error occurred while logging out.")
                }
            })
            .catch(error => {
                console.error('Logout error:', error);
                notifyError("An error occurred while logging out.");
            });
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className="user-menu">
            <DropdownToggle caret color="light" className="focus-ring" title={account?.name}>
                <FaRegCircleUser size="2rem" />
            </DropdownToggle>
            <DropdownMenu style={{ overflowY: 'auto' }}>
                <DropdownItem disabled><strong>{account?.name}</strong></DropdownItem>
                <DropdownItem disabled>{account?.username}</DropdownItem>
                <DropdownItem divider />
                <DropdownItem className="focus-ring" onClick={logout}>Sign out</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    )
}
